import { SwitchFormComponent } from "components/Form/components/Switch/SwitchFormComponent";
import { Field } from "react-final-form";

export const SimpleSwitchField = ({
    name,
    defaultValue,
    initialValue,
    onChange,
    label,
    isDisabled,
    docs,
}: {
    name: string;
    onChange?: (e?: any) => void;
    defaultValue?: boolean;
    initialValue?: boolean;
    label?: string;
    isDisabled?: boolean;
    docs?: { text?: string; urlPath?: string; url?: string };
}) => (
    <Field name={name} defaultValue={defaultValue} initialValue={initialValue}>
        {({ input, fieldProps, fieldAttr, meta }) => (
            <SwitchFormComponent
                input={{
                    ...input,
                    onChange: (e) => {
                        input.onChange(e);
                        onChange?.();
                    },
                }}
                fieldAttr={{
                    ...fieldAttr,
                    disabled: isDisabled,
                }}
                fieldProps={{
                    ...fieldProps,
                    label,
                    ...(docs ? { docs } : {}),
                }}
                meta={meta}
            />
        )}
    </Field>
);
